/**
 * Whether the runtime's IANA database knows this zone. `Intl` is the only source that always
 * matches what the app can actually format with, so it beats any list kept by hand.
 */
export const isKnownTimeZone = (timeZone: string) => {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone });
    return true;
  } catch {
    return false;
  }
};

export const formatPublishedAtDate = (date: Date) => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
